import { CompanySelectionService } from '@App/app/shared/services/company-selection/company-selection.service';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCompanySelectionDirective } from '../shared/base-company-selection.component';

@Component({
  selector: 'app-company-selection-drop-down',
  templateUrl: './company-selection-drop-down.component.html',
  styleUrls: ['./company-selection-drop-down.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanySelectionDropDownComponent extends BaseCompanySelectionDirective {
  constructor(route: ActivatedRoute, companySelectionService: CompanySelectionService) {
    super(route, companySelectionService);
  }
}
